import ReportsTable from './ReportsTable';
import AttToken from '../../helpers/attToken';
import Reports, { filterDataType } from '../../service/Reports';
import { useTranslation } from 'react-i18next';
import QueryFn from '../../helpers/QueryFn';

const reportsService = new Reports();
const queryFn = new QueryFn();

export default function ReportsComponent() {
  const { t } = useTranslation('translation');

  const { data, isLoading, isError } = queryFn.useFetch('Reports',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          const response = await reportsService.getData(token);
          return response;
        }
      } catch (error) {
        console.error(error);
      }
    },
  );

  if (isError) {
    return <span>{t('Reports.reportsTable.errorFetchingData')}</span>;
  }

  return (
    <div>
      <ReportsTable data={data?.filterData as filterDataType} loading={isLoading} />
    </div>
  );
}